/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_DOCUMENT(state, item) {
    state.documents.unshift(item)
  },
  SET_BILANF(state, documents) {
    state.bilan_f = documents
  },
  SET_BILANC(state, documents) {
    state.bilan_c = documents
  },
  SET_DOCUMENTS(state, documents) {
    state.documents = documents
  },
  SET_FORMATEUR(state, formateur) {
    state.formateur = formateur
  },
  SET_GROUPES(state, groupes) {
    state.groupes = groupes
  },
  SET_CANDIDAT(state, candidats) {
    state.candidats = candidats
  },
  SET_SEANCES(state, seances) {
    state.seances = seances
  },
  ADD_ITEM(state, item) {
    state.users.unshift(item)
  },
  ADD_DOCUMENT(state, item) {
    state.documents.unshift(item)
  },
  SET_USERS(state, users) {
    state.users = users
  },
  REMOVE_DOCUMENT(state, itemId) {
    const userIndex = state.documents.findIndex((u) => u.id == itemId)
    state.documents.splice(userIndex, 1)
},
  REMOVE_RECORD(state, itemId) {
      const userIndex = state.users.findIndex((u) => u.id == itemId)
      state.users.splice(userIndex, 1)
  },
  REMOVE_PARTICIPATION(state, itemId) {
    const userIndex = state.candidats.findIndex((u) => u.id == itemId)
    state.candidats.splice(userIndex, 1)
  },
  UPDATE_USERS(state, user) {
    const eventIndex = state.users.findIndex((e) => e.id == user.id)
    Object.assign(state.users[eventIndex], user)
},
UPDATE_CANDIDAT(state, user) {
  const eventIndex = state.candidats.findIndex((e) => e.id == user.id)
  Object.assign(state.candidats[eventIndex], user)
},
}
